import { ref as d, watch as p, provide as v, computed as C } from "vue";
import { collapseContextKey as h } from "./index614.js";
import { useNamespace as E } from "./index559.js";
import { isPromise as n } from "./index575.js";
import { isBoolean as b } from "./index565.js";
import { throwError as N, debugWarn as P } from "./index588.js";
import { UPDATE_MODEL_EVENT as O, CHANGE_EVENT as x } from "./index584.js";
import u from "./index764.js";
const m = "ElCollapse", w = (r, l) => {
  const s = d(u(r.modelValue)), c = (o) => {
    s.value = o;
    const e = r.accordion ? s.value[0] : s.value;
    l(O, e), l(x, e);
  }, i = (o) => {
    if (r.accordion)
      c([s.value[0] === o ? "" : o]);
    else {
      const e = [...s.value], t = e.indexOf(o);
      t > -1 ? e.splice(t, 1) : e.push(o), c(e);
    }
  }, f = async (o) => {
    const { beforeCollapse: e } = r;
    if (!e) {
      i(o);
      return;
    }
    const t = e(o);
    [
      n(t),
      b(t)
    ].includes(!0) || N(
      m,
      "beforeCollapse must return type `Promise<boolean>` or `boolean`"
    ), n(t) ? t.then((a) => {
      a !== !1 && i(o);
    }).catch((a) => {
      P(m, `some error occurred: ${a}`);
    }) : t && i(o);
  };
  return p(
    () => r.modelValue,
    () => s.value = u(r.modelValue),
    { deep: !0 }
  ), v(h, {
    activeNames: s,
    handleItemClick: f
  }), {
    activeNames: s,
    setActiveNames: c
  };
}, I = (r) => {
  const l = E("collapse");
  return {
    rootKls: C(() => [
      l.b(),
      l.b(`icon-position-${r.expandIconPosition}`)
    ])
  };
};
export {
  w as useCollapse,
  I as useCollapseDOM
};
